import { render, staticRenderFns } from "./contactView.vue?vue&type=template&id=6fb6587c&scoped=true"
import script from "./contactView.vue?vue&type=script&lang=js"
export * from "./contactView.vue?vue&type=script&lang=js"
import style0 from "./contactView.vue?vue&type=style&index=0&id=6fb6587c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.99.9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6587c",
  null
  
)

export default component.exports